import React from 'react';
import FAQSection from '../Components/FAQ/Faq';
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Breadcrumbs from '../Components/banner/New-banner';
function Faqpages () {
    return(
        <>
        
        <Combaintop/>
        <Breadcrumbs/>
        <FAQSection/>
        <Combainbottom/>
        </>
    );
}

export default Faqpages;